// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"2ca2746b","154":"2ca2746b","170":"2011c12b","297":"2ca2746b","440":"2ca2746b","453":"3326effb","678":"2ca2746b","773":"2ca2746b","941":"e592349b"}[chunkId] + ".chunk.js";
};